/**
 * Lista de tipos de dados que podem ser extraidos de um documento / linha / palavra.
 * Remete diretamente ao Enum DataValueType do FilesAPI
 */
enum WordDataTypeEnum {
  cpf = 1,
  cnpj = 2,
  caepf = 4,
  cei = 8,
  stateRegistration = 16,
  currency = 32,
  dateTime = 64,
  number = 128,
  text = 256,
  nfeKey = 512,
  table = 1024,
  /**
   * Este enum não existe na API
   */
  entity = 2048,
  /**
   * Este enum não existe na API
   */
  switch = 4096,
  /**
   * Este enum não existe na API
   */
  barcode = 8192,
}

const wordDataTypeDisplay: Record<string, string> = {
  text: 'Texto',
  date: 'Data',
  dateTime: 'Data',
  currency: 'Moeda',
  number: 'Número',
  table: 'Tabela',
  nfekey: 'Chave NFe',
  cpf: 'CPF',
  cnpj: 'CNPJ',
  caepf: 'CAEPF',
  cei: 'CEI',
  stateRegistration: 'Registro Estadual',
};

export { wordDataTypeDisplay, WordDataTypeEnum };
